export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_119.2ae9ef77.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};